import { TextButton } from '@components/Buttons';
import { Stack, SxProps } from '@mui/system';
import { FormFieldType, IFormFieldRow } from 'types/common';
import React, { useCallback, useMemo } from 'react';
import FieldRow from './FieldRow';

const emptyFieldRow = {
	type: FormFieldType.string,
	key: '',
	value: ''
} as IFormFieldRow;

interface IFieldRowsProps {
	name: string;
	required?: boolean;
	onChange: (rows: IFormFieldRow[]) => void;
	rows: IFormFieldRow[];
	sx?: SxProps;
	formik: any;
}
const FieldRows = ({
	name,
	onChange,
	rows,
	required,
	formik,
	sx
}: IFieldRowsProps) => {
	const rowsToUse = useMemo(() => rows || [], [rows]);

	const handleRowChange = useCallback(
		(index: number, row: IFormFieldRow) => {
			const newRows = [...rowsToUse];
			newRows[index] = row;
			onChange(newRows);
		},
		[onChange, rowsToUse]
	);
	const handleDeleteRow = useCallback(
		(index: number) => {
			const newRows = [...rowsToUse];
			newRows.splice(index, 1);
			onChange(newRows);
			if (newRows.length === 0) {
				formik.setFieldError(name, 'error');
			}
		},
		[rowsToUse, formik, name, onChange]
	);
	const handleNewRow = useCallback(() => {
		const newRows: IFormFieldRow[] = [...rowsToUse, { ...emptyFieldRow }];
		onChange(newRows);
	}, [rowsToUse, onChange]);

	return (
		<Stack flexDirection="column" data-testid="field-rows" sx={sx}>
			{rowsToUse.map((row, i) => (
				<FieldRow
					// eslint-disable-next-line react/no-array-index-key
					key={i}
					index={i}
					name={name}
					deletable={!required || rowsToUse.length > 1}
					onChange={handleRowChange}
					onDelete={handleDeleteRow}
					row={row}
				/>
			))}
			<TextButton
				onClick={handleNewRow}
				sx={{ textDecoration: 'none', justifyContent: 'flex-start' }}
				data-testid="field-rows-add-button"
			>
				{intl.tr('input.object.add')}
			</TextButton>
		</Stack>
	);
};

FieldRows.defaultProps = {
	sx: undefined,
	required: undefined
};

export { emptyFieldRow };
export type { IFieldRowsProps };
export default FieldRows;
